import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	stickyBar: {
		background: theme.palette.secondary.main,
		color: theme.palette.secondary.contrastText
	}
}));

export default useStyles;
